import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

import LoadingSection from 'components_new/molecules/LoadingSection'

interface Props {
  sx?: SxProps
}

const Loading = React.memo((props: Props) => {
  const { sx } = props

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Skeleton sx={sx} width="25%" />

        <Box sx={{ display: 'flex', gap: 0.5 }}>
          {[1, 2, 3, 4].map((i) => (
            <Skeleton
              height={24}
              key={i}
              sx={sx}
              variant={i <= 2 ? 'rounded' : 'circular'}
              width={i <= 2 ? 64 : 24}
            />
          ))}
        </Box>
      </Box>
      <Skeleton height="40px" sx={sx} width="12.5%" />

      <LoadingSection />
    </>
  )
})

export default Loading
